import { render, staticRenderFns } from "./CleverreachStatus.vue?vue&type=template&id=5afa485e&"
import script from "./CleverreachStatus.vue?vue&type=script&lang=js&"
export * from "./CleverreachStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports